module.exports = __webpack_public_path__ + "static/media/neogrid.ea483e40.png";